import classNames from 'classnames'
import * as React from 'react'

import Link from '@/components/Link'

const themes = {
  dark: 'text-purple-900 hover:text-purple-400',
  light: 'text-white hover:text-yellow-400',
}

const FooterItem = ({label, link, obfuscate, theme = 'dark'}) => {
  return (
    <Link link={link} className={classNames('body-m-regular', themes[theme])} obfuscate={obfuscate}>
      {label}
    </Link>
  )
}

export default FooterItem
